import { Nav } from 'react-bootstrap';
import './navbar.css';
import { animate, stagger} from 'animejs';
import {  useRef, useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const hamburgerRef = useRef(null);

  const toggleMenu = () => {
    console.log('Menu toggled!');
    setIsOpen(!isOpen);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  if (isOpen) {
    animate('.sidebar',{
      translateX: ['-100%', '0%'],
      duration: 100,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(1)', {
      rotate: 0,
        translateX: -100,
        duration: 300,
        easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(2)', {
      rotate: 0,
      translateX: -100,
      duration: 250,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(3)', {
      rotate: 0,
      translateX: -100,
      duration: 200,
      easing: 'easeOutQuad'
    });
    animate('.nav-link', {
      opacity: [0, 1],
      translateX: ['-20px', '0px'],
      delay: stagger(100),
      duration: 600,
      easing: 'easeOutQuad'
    });
  }
  else{
    animate('.sidebar',{
      translateX: ['0%', '-100%'],
      duration: 100,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(1)', {
      rotate: 0,
        translateX: 0,
        duration: 300,
        easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(2)', {
      rotate: 0,
      translateX: 0,
      duration: 250,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(3)', {
      rotate: 0,
      translateX: 0,
      duration: 200,
      easing: 'easeOutQuad'
    });
    animate('.nav-link', {
      rotate: 0,
      translateY: 0,
      duration: 400,
      easing: 'easeOutQuad'
    });
  }
  
  return (
    <>
      <div 
        className={`hamburger-menu ${isOpen ? 'open' : 'close'}`} 
        onClick={toggleMenu}
        ref={hamburgerRef}
      >
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
      </div>
      
      <div 
        className={`sidebar ${isOpen ? 'open' : ''}`}
      >
        <div className="sidebar-header">
          <a href="#home" className="sidebar-brand" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>
            Vincent Le
          </a>
        </div>
        
        <Nav className="sidebar-nav flex-column">
          <Nav.Link 
            as="a" 
            href="#home" 
            onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
          >
            <i className="fas fa-home"></i>
            <span>Home</span>
          </Nav.Link>
          <Nav.Link 
            as="a" 
            href="#about" 
            onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}
          >
            <i className="fas fa-user"></i>
            <span>About</span>
          </Nav.Link>
          <Nav.Link 
            as="a" 
            href="#projects" 
            onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}
          >
            <i className="fas fa-code"></i>
            <span>Projects</span>
          </Nav.Link>
          <Nav.Link 
            as="a" 
            href="#resume" 
            onClick={(e) => { e.preventDefault(); scrollToSection('resume'); }}
          >
            <i className="fas fa-file-alt"></i>
            <span>Resume</span>
          </Nav.Link>
          <Nav.Link 
            as="a" 
            href="#contact" 
            onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}
          >
            <i className="fas fa-envelope"></i>
            <span>Contact</span>
          </Nav.Link>
        </Nav>
        
        <div className="sidebar-footer">
          <a href="https://github.com/VincentDev21" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github"></i>
          </a>
          <a href="https://www.linkedin.com/in/vincent-le-21929a215/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin"></i>
          </a>
        </div>
      </div>
      
      {/* Overlay to close menu when clicking outside */}
      {isOpen && <div className="sidebar-overlay" onClick={() => setIsOpen(false)}></div>}
    </>
  );
};

export default Navbar;